import { privateApi } from "../utils/axios";

// Fetch all expenses for a specific event
export const getEventBudgetCategories = async (eventId) => {
  const response = await privateApi.get(`/events/${eventId}/budgets`);
  return response.data;
};

//Fetch all expenses for multiple events
export const getEventsBudgetCategories = async (eventIds) => {
  const response = await privateApi.get(`/events/multi-view/budgets?eventIds=${eventIds.join(',')}`);
  return response.data;
};

// Create a new budget category for a specific event
export const createBudgetCategory = async (eventId, categoryData) => {
  const response = await privateApi.post(`/events/${eventId}/budgets`, categoryData);
  return response.data;
};

// Fetch specific expense
export const getBudget = async (categoryId) => {
    const response = await privateApi.get(`/budgets/${categoryId}`);
    return response.data;
  };

// Update a budget category
export const updateBudgetCategory = async (categoryId, categoryData) => {
  const response = await privateApi.put(`/budgets/${categoryId}`, categoryData);
  return response.data;
};

// Delete a budget category
export const deleteBudgetCategory = async (categoryId) => {
  const response = await privateApi.delete(`/budgets/${categoryId}`);
  return response.data;
};

// Update total budget for the event
export const updateTotalBudget = async (eventId, total_budget) => {
  const response = await privateApi.put(`/events/${eventId}/budget`, { total_budget });
  return response.data;
};

// Get splits for a budget category
export const getBudgetSplits = async (categoryId) => {
  const response = await privateApi.get(`/budgets/${categoryId}/splits`);
  return response.data;
};

// Create or update splits for a budget category
export const updateBudgetSplits = async (categoryId, { splits, split_type }) => {
  const response = await privateApi.put(`/budgets/${categoryId}/splits`, { splits, split_type });
  return response.data;
};

// Delete splits for a budget category
export const deleteBudgetSplits = async (categoryId) => {
  const response = await privateApi.delete(`/budgets/${categoryId}/splits`);
  return response.data;
};

// Get all split users for an event
export const getEventSplitUsers = async (eventId) => {
  const response = await privateApi.get(`/budgets/${eventId}/users`);
  return response.data;
};